module.exports = __webpack_public_path__ + "img/imagen1.13686ec5.png";